import { render, staticRenderFns, recyclableRender, components } from "./u-safe-bottom.vue?vue&type=template&id=758fd84f&scoped=true&"
var renderjs
import script from "./u-safe-bottom.vue?vue&type=script&lang=js&"
export * from "./u-safe-bottom.vue?vue&type=script&lang=js&"
import style0 from "./u-safe-bottom.vue?vue&type=style&index=0&id=758fd84f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758fd84f",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-safe-bottom/u-safe-bottom.vue"
export default component.exports